import { getCurrentScope, onScopeDispose, watch, type Ref } from "vue";
import type { Map as MapLibreMap } from "maplibre-gl";
import { warmRoutingAround } from "./useClientRouting";

const DEBOUNCE_MS = 400;

// Пока активны редактор маршрута или линейка (active), держим в кэше тайлы графа
// вокруг центра карты: при включении и после каждого сдвига карты. Тогда первый
// же отрезок считается без ожидания сети.
export function useRoutingPrefetch(ctx: { getMap: () => MapLibreMap | null }, active: Ref<boolean>): void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let attached: MapLibreMap | null = null;

  const run = () => {
    const map = ctx.getMap();
    if (!map) return;
    const c = map.getCenter();
    void warmRoutingAround(c.lng, c.lat);
  };
  const onMoveEnd = () => {
    if (timer != null) clearTimeout(timer);
    timer = setTimeout(run, DEBOUNCE_MS);
  };
  const stop = () => {
    if (timer != null) clearTimeout(timer);
    timer = null;
    attached?.off("moveend", onMoveEnd);
    attached = null;
  };
  const start = () => {
    const map = ctx.getMap();
    if (!map || attached) return;
    attached = map;
    map.on("moveend", onMoveEnd);
    run();
  };

  watch(active, (v) => (v ? start() : stop()), { immediate: true });
  if (getCurrentScope()) onScopeDispose(stop);
}
